import $ from 'jquery';
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { showBudgetBidCampaignNotifications } from '@bingads-webui-campaign/import-shared-utils';
import { BudgetNotEditableView } from './budget';
import budgetTemplate from './budget-template.pug';
import unpurposedBudgetTemplate from './unpurposed-budget-template.pug';

export class BudgetColumn extends CampaignuiBaseColumn {
  constructor(options) {
    const { dynamic } = options.permissions || {};
    const {
      CampaignLifetimeBudget,
      MaeLifetimeBudgetExclusion,
    } = dynamic || {};

    const isCampaignLifetimeBudgetEnabled = CampaignLifetimeBudget && !MaeLifetimeBudgetExclusion;

    const title = options.i18n.getString(isCampaignLifetimeBudgetEnabled ? 'ColumnName_DailyBudgetAmount' : 'ColumnName_BudgetAmount');

    super({
      name: 'Budget',
      property: ['Budget', 'DeliveryStatus', 'DeliveryStatusDetails', 'IsBidLandscapeAvailable', 'BiddingScheme', 'BidStrategyName', 'ImportProperties'],
      title,
      sortable: 'Budget/Amount',
      editable: true,
      enableEdit: item => item.Budget?.Type === 'DailyStandard',
      type: 'number',
      helpId: 'pop_BA_Campaigns_DailyBudget',
      helpAriaLabel: options.i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.delta = 0;
    this.resetDelta = null;
    this.view = options.view;
    this.i18n = options.i18n;
    this.schemaI18n = options.schemaI18n;
    this.numberFormatter = options.i18n.decimalToFixedFormatter(2);
    this.InlineSharedBudgetEditor = options.InlineSharedBudgetEditor;
    this.InlineBudgetEditor = options.InlineBudgetEditor;
    this.budgetTemplate = options.budgetTemplate || budgetTemplate;
    this.decimal = options.decimal;
    this.permissions = options.permissions;
    this.isForVNext = options.isForVNext;
    this.isCampaign = options.isCampaign;
  }

  pickProperty(item) {
    const propertys = {
      Budget: item.Budget,
      DeliveryStatus: item.DeliveryStatus,
      IsBidLandscapeAvailable: item.IsBidLandscapeAvailable,
      BiddingScheme: item.BiddingScheme,
      DeliveryStatusDetails: item.DeliveryStatusDetails,
      BidStrategyName: item.BidStrategyName,
    };
    propertys.AssociatedExperiment = item.AssociatedExperiment;
    return propertys;
  }

  onPrompt({
    position, item, event, newPosition,
  }) {
    if ($(event.target).hasClass('experiment-budget-ellipsis')) {
      // already handled in grid
      return null;
    }

    if ($(event.target).hasClass('bidlandscape_icon')) {
      // already handled in campaigns-grid.es
      return null;
    }
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    if (item.ExperimentId > 0) {
      const budgetNotEditableView = new BudgetNotEditableView({ i18n: this.i18n }).render();

      return new GridCustomizedPopupEditor({
        editorView: budgetNotEditableView,
        cellPosition: position,
        renderBelow: false,
        className: `grid-popupeditor ${groupClass}`,
      }).render();
    }

    const { instrumentation } = this.view;
    let budgetBidCampaignImportNotificationActivity;
    if (instrumentation) {
      budgetBidCampaignImportNotificationActivity = instrumentation.createScenarioAndActivity({
        scenarioName: 'BudgetBidCampaignImportNotification',
        activityName: 'CampaignsGridBudgetColumn',
      }).activity;
    }


    if (item.Budget.Id) {
      // shared budget
      const sharedBudgetEditor = new this.InlineSharedBudgetEditor({
        model: {
          budgetAmount: item.Budget.Amount,
          budgetType: item.Budget.Type,
          budgetName: item.Budget.Name,
          budgetId: item.Budget.Id,
          campaignId: item.Id,
          permissions: this.permissions,
          DeliveryStatus: item.DeliveryStatus,
          DeliveryStatusDetails: item.DeliveryStatusDetails,
        },
        renderAsPopup: true,
        $elToBlock: this.view.grid.gridView.$el,
        isForVNext: this.isForVNext,
        importNotificationCallback: (newBudget) => {
          showBudgetBidCampaignNotifications({
            campaignItemList: [item], oldBudget: item.Budget, newBudget, activity: budgetBidCampaignImportNotificationActivity,
          });
        },
      });

      sharedBudgetEditor.on('close', () => {
        this.view.grid.gridView.refresh(true);
      });

      const editorView = new GridCustomizedPopupEditor({
        editorView: sharedBudgetEditor.render(),
        cellPosition: this.isForVNext ? newPosition : position,
        renderBelow: false,
        className: `grid-popupeditor ${groupClass}`,
        parentContainerSelector: this.isForVNext ? '.grid-and-disclaim-container' : null,
      });

      return editorView.render();
    } else if (item.Budget.Amount) {
      const editor = new this.InlineBudgetEditor({
        item,
        $elToBlock: this.view.grid.gridView.$el,
        isForVNext: this.isForVNext,
        permissions: this.permissions,
        showBudgetMinRecommend: this.permissions.dynamic && this.permissions.dynamic.BCCBudgetImprovementEnabled,
        currencySymbol: this.i18n.getCurrencySymbol(),
        clientName: this.isCampaign ? 'CampaignTabEditing' : 'AllCampaignSetting',
        perfMarker: this.view.campaignTabPerfMarker,
        importNotificationCallback: (newBudget) => {
          showBudgetBidCampaignNotifications({
            campaignItemList: [item], oldBudget: item.Budget, newBudget, activity: budgetBidCampaignImportNotificationActivity,
          });
        },
      });

      editor.on('close', (update) => {
        if (update) {
          this.view.grid.gridView.refresh(true);
        }
      });

      const editorView = new GridCustomizedPopupEditor({
        editorView: editor.render(),
        cellPosition: this.isForVNext ? newPosition : position,
        renderBelow: false,
        className: 'grid-popupeditor'.concat(` ${groupClass}`).concat(this.permissions.IsBudgetInlineSuggestionEnabled ? ' inline-budget-editor-popup' : ''),
        parentContainerSelector: this.isForVNext ? '.grid-and-disclaim-container' : null,
      });

      editorView.render();
      return editorView;
    }
    return _.noop;
  }

  template({ value }) {
    let params = null;
    const enabledStatus = ['Eligible', 'InlineOpportunity', 'AutoBiddingLimitedUnAttainableTarget'];
    const autoBiddingTarget = ['TargetCpa', 'TargetRoas'];
    const maxConversionTarget = ['MaxConversionValue', 'MaxConversions'];
    const whiteList = [
      'ManualCpc',
      'EnhancedCpc',
      ...this.permissions.dynamic && this.permissions.dynamic.SimulatorForCPAROAS ? autoBiddingTarget : [],
      ...this.permissions.IsPmaxBidLandscapeEnabled ? maxConversionTarget : [],
    ];
    const biddingSchemeType = _.result(value.BiddingScheme, 'Type', null);
    const inWhiteList = _.contains(whiteList, biddingSchemeType);
    const enabledBidlandscapeForLimited = value.DeliveryStatus === 'AutoBiddingLimitedUnAttainableTarget' && (_.every(value.DeliveryStatusDetails, detail => _.contains(enabledStatus, detail)));
    const enabledBidlandscape = (value.DeliveryStatus === 'Eligible' || value.DeliveryStatus === 'InlineOpportunity' || enabledBidlandscapeForLimited) && value.IsBidLandscapeAvailable;
    let hasBidlandscapeIcon = !this.permissions.IsReadOnlyUser && inWhiteList && !value.BidStrategyName; // portfolio campaign has no support
    if (_.contains(autoBiddingTarget, biddingSchemeType)) {
      hasBidlandscapeIcon = hasBidlandscapeIcon && !value.Budget.Id;
    }
    if (_.contains(maxConversionTarget, biddingSchemeType)) {
      hasBidlandscapeIcon = hasBidlandscapeIcon && (!_.isNull(_.result(value.BiddingScheme, 'TargetCpa', null)) || !_.isNull(_.result(value.BiddingScheme, 'TargetRoas', null)));
    }

    if (value.Budget) {
      if (value.Budget.Type === 'LifetimeBudgetStandard') {
        return unpurposedBudgetTemplate();
      }

      const isBudgetCenterEntryEnabled = this.permissions.dynamic && !this.permissions.dynamic.IsSmartPageStandalone && !this.permissions.IsUnifiedSmartMode && !this.permissions.IsSmartMode
        && _.isNumber(value.Budget.MonthlyAmount);
      // aggregated row budget
      if (_.isNumber(value.Budget.DailyBudget)) {
        params = {
          budgetAmount: this.decimal.fromFloatToString(value.Budget.DailyBudget + this.delta),
          budgetTypeText: this.schemaI18n.value('Budget', 'ShortType', 'DailyStandard'),
          budgetName: null,
          budgetId: 0,
          enabledBidlandscape,
          hasBidlandscapeIcon,
          isBudgetCenterEntryEnabled,
          i18n: this.i18n,
        };
      } else {
        params = {
          budgetAmount: this.decimal.fromFloatToString(value.Budget.Amount),
          budgetType: value.Budget.Type,
          budgetTypeText: this.schemaI18n.value('Budget', 'ShortType', value.Budget.Type),
          budgetName: value.Budget.Name,
          budgetId: value.Budget.Id,
          enabledBidlandscape,
          hasBidlandscapeIcon,
          isBudgetCenterEntryEnabled,
          i18n: this.i18n,
        };
      }

      params.AssociatedExperiment = value.AssociatedExperiment;
    }

    return this.budgetTemplate({
      model: params,
    });
  }
}
